import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert, types } from 'react-alert';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import { PageTitle, PaperWithTitle, PagingTable } from '../../../components';
import { useReceipt } from '../../../../model/hooks/payment/ReceiptHooks';
import { pagination } from '../../../../common/constants/Constants';
export const ReceiptList = () => {
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const { columns, loading, loadReceipts } = useReceipt();
    const [rows, setRows] = useState([]);
    const loadData = async (id = null) => {
        const result = await loadReceipts(pagination.limit, id);
        return result;
    };
    const onMore = async () => {
        if (rows.length > 0) {
            const lastRow = rows.slice(-1)[0];
            const _rows = await loadData(lastRow.id);
            if (_rows.length > 0) {
                setRows(rows.concat(_rows));
            }
        }
    };
    useEffect(() => {
        const f = async () => {
            try {
                const _rows = await loadData();
                setRows(_rows);
            }
            catch (e) {
                if (e instanceof Error) {
                    reactAlert.show(e.message, { type: types.ERROR });
                }
            }
        };
        f();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('領収書一覧')),
        React.createElement(SGrid, { container: true },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PaperWithTitle, { title: "\u9818\u53CE\u66F8\u4E00\u89A7" },
                    React.createElement(PagingTable, { columns: columns, rows: rows, loading: loading, onClickExpandMore: onMore }))))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
